/**
 * Doppelklick-Bremse fuer "In den Warenkorb" (Sam)
 * Verhindert, dass ein hastiger zweiter Klick waehrend eines laufenden
 * Add-to-Cart-Vorgangs eine zweite Bestellzeile/Menge ausloest.
 *
 * Anders als die erste Version: das disabled-Attribut des Buttons wird
 * NICHT angefasst. Stattdessen blockt eine einfache JS-Merkervariable
 * (isSubmitting) nur wiederholte Klicks waehrend der Verarbeitung.
 * Der erste Klick laeuft dadurch komplett unveraendert durch den
 * Theme-Kern - das war vermutlich der Bruchpunkt der ersten Version.
 *
 * v4 (29.08.2026): Selektor von [data-action="add-to-cart"] auf
 * button.product-form__add-button umgestellt, da das Theme-Update auf
 * Version 7.0.1 das data-action-Attribut entfernt und den Button in
 * ein <buy-button>-Custom-Element gewrappt hat. Ohne diese Anpassung
 * griff die Bremse gar nicht mehr (kein Fehler, aber wirkungslos).
 */
(function () {
  // Merker: laeuft gerade ein Add-to-Cart-Vorgang?
  var isSubmitting = false;

  // Text, der waehrend der Verarbeitung im Button angezeigt wird
  var LOADING_TEXT = 'Schnäppchen sichern...';

  // Nach dieser Zeit wird der Button auch ohne 'product:added'-Event
  // wieder freigegeben (Sicherheitsnetz, z.B. bei Lagerfehlern)
  var SAFETY_TIMEOUT_MS = 5000;

  document.addEventListener('click', function (event) {
    // Pruefen, ob der Klick auf (oder in) einem Add-to-Cart-Button war
    var button = event.target.closest ? event.target.closest('button.product-form__add-button[type="submit"]') : null;
    if (!button) return;

    // Vorgang laeuft bereits -> diesen (zweiten) Klick ignorieren
    if (isSubmitting) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    // Urspruenglichen Button-Inhalt merken, um ihn spaeter wiederherzustellen
    var originalHTML = button.innerHTML;

    // Ersten Klick durchlassen, aber Folgeklicks ab jetzt sperren
    isSubmitting = true;
    button.classList.add('is-adding'); // nur optisch/interaktiv, siehe CSS
    button.textContent = LOADING_TEXT;

    var safetyTimeoutId;

    // Gibt den Button wieder frei (nach Erfolg oder nach Timeout)
    var reset = function () {
      isSubmitting = false;
      button.classList.remove('is-adding');
      button.innerHTML = originalHTML;
      document.removeEventListener('product:added', reset);
      clearTimeout(safetyTimeoutId);
    };

    // Theme-eigenes Event: feuert, sobald ein Produkt erfolgreich
    // in den Warenkorb gelegt wurde
    document.addEventListener('product:added', reset);

    // Sicherheitsnetz, falls das Event mal ausbleibt
    safetyTimeoutId = setTimeout(reset, SAFETY_TIMEOUT_MS);
  }, true); // Capture-Phase: feuert vor der internen Klick-Verarbeitung
})();